import React, {useContext, useEffect, useMemo, useState} from 'react'
import {Button, Col, Form, ListGroup, Row} from 'react-bootstrap'
// import { ListTags } from '../documentInterface';
import * as excelJs from 'exceljs'
import Select from 'react-select'
import {useUserInfo} from 'src/app/routing/store/InfoUserProvider'
import {fichasxid} from 'src/app/services/fichas'
import {formatDateToDMY} from '../../../../helpers/dateFunctions'
import {actualizarCampoCheckExcel} from '../../../../services/campos'
import {getUnidadesEmpresas} from '../../../../services/companies'
import {showMessage} from '../../../../shared/Alerts'
import {useGlobalOverlayLoading} from '../../../../shared/hooks/useGlobalOverlayLoading'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {PdfLoadingSpinner} from '../../../generales_component/PdfLoadingSpinner'
import {ListFieldsExport} from '../../documento/documentInterface'
import {Field, Section} from '../../fichas/Sheet'
import {PartnerContext} from '../PartnerContexts'

interface MyProps {
  List: ListFieldsExport[]
}

type Columns = {Ficha: string; Seccion: string; Campo: string; Type: string; Value: string}[]

const TagsListGroup: React.FC<MyProps> = ({List}) => {
  const {
    fichaData,
    idficha,
    typeUpdate,
    setIdFicha,
    setSheetId,
    sheet,
    loadingFichaContent,
    closeFichaPlantillaModal,
    setFichaData,
    processId,
  } = useContext(PartnerContext)
  const {procesosAdmin} = useUserInfo()

  const processSelectedInContext = useMemo(() => processId.split(','), [processId])
  const processToShow = useMemo(
    () =>
      processSelectedInContext.includes('all')
        ? procesosAdmin
        : procesosAdmin?.filter((p) => processSelectedInContext.includes(p.id)),
    [processSelectedInContext, procesosAdmin]
  )

  const {selectedCompanyId, userData} = useAuth2()
  const [searchQuery, setSearchQuery] = useState('')
  const [inputList, setInputList] = useState(List)
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const {setGlobalOverlayLoading} = useGlobalOverlayLoading()

  const [selectedProcess, setSelectedProcess] = useState('')

  const forcedSelections = [
    'CS_ApPaterno',
    'CS_ApMaterno',
    'CS_Nombres',
    'CS_Documento',
    'CS_EmailPersonal',
  ]
  const forcedSelectionsUpdate = ['CS_Documento']

  useEffect(() => {
    setInputList(List)
  }, [List])

  useEffect(() => {
    if (!selectedProcess) {
      setSelectedProcess(processToShow?.[0]?.id ?? '')
    }
  }, [processToShow])

  useEffect(() => {
    changeDefault()
  }, [inputList])

  const changeDefault = () => {
    const idSelected: string[] = []

    inputList.forEach((group) => {
      group.fields.forEach((field: any) => {
        if (
          field.check ||
          (forcedSelections.includes(field.assignedTo) && !typeUpdate) ||
          (forcedSelectionsUpdate.includes(field.assignedTo) && typeUpdate)
        ) {
          idSelected.push(field.identifier)
        }
      })
    })
    setSelectedItems(idSelected)
  }

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }

  const handleToggle = (id: string) => {
    const currentIndex = selectedItems.indexOf(id)
    const newSelected = [...selectedItems]
    if (currentIndex === -1) {
      newSelected.push(id)
    } else {
      newSelected.splice(currentIndex, 1)
    }
    setSelectedItems(newSelected)
  }

  const handleChangeAll = (event: any) => {
    if (event.target.checked) {
      const arrSelect: string[] = []
      inputList.forEach((group) => {
        group.fields.forEach((field) => {
          arrSelect.push(field.identifier)
        })
      })
      setSelectedItems(arrSelect)
    } else {
      const arrSelect: string[] = []
      inputList.forEach((group) => {
        group.fields.forEach((item) => {
          if (
            (forcedSelections.includes(item.assignedTo) && !typeUpdate) ||
            (forcedSelectionsUpdate.includes(item.assignedTo) && typeUpdate)
          ) {
            arrSelect.push(item.identifier)
          }
        })
      })

      setSelectedItems(arrSelect)
    }
  }

  const handleExport = () => {
    setGlobalOverlayLoading(true)
    const sectionsFilters: Section[] = []
    const camposDesplegableBD: any[] = []
    const camposIdDesplegableBD: any[] = []
    const notSelectItems: string[] = []
    const columns: {Ficha: string; Seccion: string; Campo: string; Type: string; Value: string}[] =
      []
    sheet.sections?.forEach((section: Section) => {
      if (section.filter) {
        sectionsFilters.push(section)
      }

      if (!section.dynamic) {
        section.fields?.forEach((field: Field) => {
          let entro = false
          selectedItems.forEach((item) => {
            if (String(field.id) === String(item)) {
              entro = true
              if (String(field.type?.[0]?.identificador) === 'dropdownlist') {
                let CadenaValue = 'ComboList : ['
                field.options?.forEach((e, it) => {
                  it === 0 ? (CadenaValue += e.label) : (CadenaValue += ', ' + e.label)
                })
                CadenaValue += ']'
                columns.push({
                  Ficha: sheet.name,
                  Seccion: section.name,
                  Campo: field.name,
                  Type: field.type?.[0].identificador
                    ? String(field.type?.[0].identificador)
                    : 'textbox',
                  Value: CadenaValue,
                })
              } else if (String(field.type?.[0]?.identificador) === 'dropdownlist_db') {
                camposDesplegableBD.push(field)
                camposIdDesplegableBD.push({[field.id]: field.name})
                columns.push({
                  Ficha: sheet.name,
                  Seccion: section.name,
                  Campo: field.name,
                  Type: field.type?.[0].identificador
                    ? String(field.type?.[0].identificador)
                    : 'textbox',
                  Value: `Tabla_${field.collectionName}`,
                })
              } else {
                columns.push({
                  Ficha: sheet.name,
                  Seccion: section.name,
                  Campo: field.name,
                  Type: field.type?.[0].identificador
                    ? String(field.type?.[0].identificador)
                    : 'textbox',
                  Value: field.type?.[0].identificador
                    ? String(field.type?.[0].identificador)
                    : 'textbox',
                })
              }
            }
          })
          if (!entro) {
            notSelectItems.push(field.id)
          }
        })
      }
    })

    console.log('camposDesplegableBD')
    console.log(camposDesplegableBD)

    if (!typeUpdate) {
      columns.push({
        Ficha: 'Fecha',
        Seccion: 'Fecha Solicitud',
        Campo: 'Fecha Solicitud',
        Type: 'date',
        Value: 'date',
      })
    }

    actualizarCampoCheckExcel({Selected: selectedItems, NotSelected: notSelectItems})
      .then((response) => {
        if (response.success) {
          closeFichaPlantillaModal()
          showMessage('success', 'Actualizacion Correctamente', response.message)
          console.log(response)
        }
      })
      .catch((error) => {
        console.log(error)
      })

    exportExcelJS(columns, sectionsFilters, camposDesplegableBD, camposIdDesplegableBD)
  }

  function cleanName(name: string): string {
    // Reemplaza los caracteres especiales con '-'
    let cleanName = name.replace(/[^a-zA-Z0-9 áéíóúÁÉÍÓÚ]/g, '-')
    return cleanName
  }

  const exportExcelJS = async (
    columns: Columns,
    sectionsFilters: Section[],
    camposDesplegableBD: any[],
    camposIdDesplegableBD: any[]
  ) => {
    const workbook = new excelJs.Workbook()
    const worksheet = workbook.addWorksheet()
    const res = await getUnidadesEmpresas([selectedCompanyId as string], userData?.userId)
    const misUnidades = res.data[0]?.unidad.filter((u: any) => u.selected)
    const camposIdDesplegableBDObject = Object.assign({}, ...camposIdDesplegableBD)

    sectionsFilters.forEach((section) => {
      section.fields?.forEach((field) => {
        const fieldExportExisting = columns.find((col) => col.Campo === field.name) ?? null
        if (fieldExportExisting != null && fieldExportExisting.Type === 'dropdownlist_db') {
          const worksheetLeyend = workbook.addWorksheet(`Leyenda-${cleanName(field.name)}`)
          field.tablaData?.forEach((data) => {
            if (field.collectionName === 'Unidades') {
              const unidadesByUser = data.value?.filter((e) =>
                misUnidades?.some((u: any) => u.codUnidad === e.id)
              )

              unidadesByUser?.forEach((u: any) => {
                worksheetLeyend.columns = [
                  {header: field.name.toUpperCase(), key: field.id, width: 20},
                  {header: 'ID', key: u.codUnidad, width: 20},
                ]

                worksheetLeyend.addRow([u.name, u.id])
              })
            } else {
              data.value?.forEach((val) => {
                worksheetLeyend.columns = [
                  {header: field.name.toUpperCase(), key: field.id, width: 20},
                  {header: 'ID', key: val.id, width: 20},
                ]

                if (field.collectionName?.toLowerCase() === 'nominas') {
                  worksheetLeyend.addRow([val.name, val.id])
                } else {
                  worksheetLeyend.addRow([val.name, val.id])
                }
              })
            }
          })

          worksheetLeyend.getRow(1).eachCell((cell) => {
            cell.font = {
              name: 'Calibri',
              size: 14,
              bold: true,
              color: {argb: 'FFFFFF'},
            }
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {argb: '0A58CA'},
            }
          })
        }
      })
    })

    camposDesplegableBD.forEach((campos) => {
      const worksheetLeyend = workbook.addWorksheet(`Leyenda-${cleanName(campos.name)}`)
      campos.tablaData?.forEach((data: any) => {
        data.value?.forEach((val: any) => {
          if (campos.dependentField !== '') {
            worksheetLeyend.columns = [
              {
                header: `ID_${camposIdDesplegableBDObject[campos.dependentField]}`,
                key: campos.id,
                width: 40,
              },
              {header: campos.name.toUpperCase(), key: campos.id, width: 40},
              {header: 'ID', key: val.id, width: 20},
            ]
          } else {
            worksheetLeyend.columns = [
              {header: campos.name.toUpperCase(), key: campos.id, width: 40},
              {header: 'ID', key: val.id, width: 20},
            ]
          }

          if (campos.dependentField !== '') {
            worksheetLeyend.addRow([val.parent_id, val.name, val.id])
          } else {
            worksheetLeyend.addRow([val.name, val.id])
          }
        })
      })

      worksheetLeyend.getRow(1).eachCell((cell) => {
        cell.font = {
          name: 'Calibri',
          size: 14,
          bold: true,
          color: {argb: 'FFFFFF'},
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: '0A58CA'},
        }
      })
    })

    const objectSeccion: {[seccion: string]: number} = {}

    columns.forEach((col) => {
      if (!objectSeccion[col.Seccion]) {
        objectSeccion[col.Seccion] = 1
      } else {
        objectSeccion[col.Seccion] = objectSeccion[col.Seccion] + 1
      }
    })

    worksheet.mergeCells(`A1:${getExcelLetter(columns.length)}1`)
    const fichaCell = worksheet.getCell('A1')
    fichaCell.value = columns[0].Ficha
    fichaCell.font = {
      name: 'Calibri',
      size: 14,
      bold: true,
      color: {argb: 'FFFFFF'},
    }
    fichaCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: '0A58CA'},
      bgColor: {argb: ''},
    }
    fichaCell.alignment = {vertical: 'middle', horizontal: 'center'}
    let Ini = 1
    let fin = 0
    Object.keys(objectSeccion).forEach((key, ind) => {
      fin = fin + objectSeccion[key]
      worksheet.mergeCells(`${getExcelLetter(Ini)}2:${getExcelLetter(fin)}2`)

      const fichaCell = worksheet.getCell(`${getExcelLetter(Ini)}2`)
      fichaCell.value = key
      fichaCell.font = {
        name: 'Calibri',
        size: 13,
        bold: true,
        color: {argb: 'FFFFFF'},
      }
      fichaCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: getRandomColorRGB()},
        bgColor: {argb: ''},
      }

      fichaCell.alignment = {vertical: 'middle', horizontal: 'center'}

      Ini = Ini + objectSeccion[key]
    })

    // Adding Header Row
    const header = columns.map((el) => el.Campo)
    const headerKeys = columns.map((el) => ({key: el.Campo}))
    const types = columns.map((el) => el.Type)
    const value = columns.map((el) => el.Value)
    const headerRow = worksheet.addRow(header)
    const contentRow = worksheet.addRow(value)
    worksheet.columns = headerKeys
    headerRow.eachCell((cell) => {
      cell.alignment = {
        horizontal: 'center',
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'DCE0F7'},
        bgColor: {argb: ''},
      }
      cell.font = {
        color: {argb: '45494E'},
        size: 12,
      }
    })

    contentRow.eachCell((cell) => {
      cell.alignment = {
        horizontal: 'center',
      }
      cell.font = {
        color: {argb: '45494E'},
        size: 12,
      }
      if (cell.value === 'date') {
        cell.value = formatDateToDMY(new Date())
        cell.numFmt = 'dd/mm/yyyy'
      }
    })

    if (worksheet.columns) {
      worksheet.columns.forEach(function (column) {
        if (column) {
          let dataMax = 0
          column.eachCell &&
            column.eachCell({includeEmpty: true}, function (cell, idx) {
              const columnLength = cell.value ? String(cell.value).length : 0
              if (columnLength > dataMax) {
                dataMax = columnLength
              }
            })
          if (column) {
            column.width = dataMax < 15 ? 15 : dataMax
          }
        }
      })
    }

    worksheet.addRows([{}, {}, {}])

    const rowToLock = worksheet.getRow(5)
    rowToLock.eachCell((cell) => {
      cell.protection = {
        locked: true,
      }
    })

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'mi_archivo_excel.xlsx'
        a.click()
      })
      .finally(() => setGlobalOverlayLoading(false))
  }

  const getExcelLetter = (number: number) => {
    let result = ''
    while (number > 0) {
      const remainder = (number - 1) % 26
      result = String.fromCharCode(65 + remainder) + result
      number = Math.floor((number - 1) / 26)
    }
    return result
  }

  const getRandomColorRGB = () => {
    const r = 0 // Genera un valor aleatorio para el componente rojo (entre 0 y 255).
    const g = 0 // Genera un valor aleatorio para el componente verde (entre 0 y 255).
    const b = Math.floor(Math.random() * 256) // Genera un valor aleatorio para el componente azul (entre 0 y 255).
    return `${r}${g}${b})` // Retorna el color en formato RGB.
  }

  const handleInputChangeFichas = (event: any) => {
    setIdFicha(event.value ?? '')
    setSheetId(event.value ?? '')
  }
  // Set a maximum height for the ListGroup container
  const maxListHeight = '300px'
  const procesosAdminOptions = processToShow.map((x) => ({value: x.id, label: x.name}))

  const getFichasxProceso = (value: string) => {
    setSheetId('')
    setIdFicha('')
    setFichaData([])
    fichasxid(value).then((response) => {
      if (response.success) {
        // setIdfichas(response.data[0]?.idficha?._id)
        setIdFicha(response?.data?.[0]?.idficha?._id ?? '')
        setSheetId(response?.data?.[0]?.idficha?._id ?? '')
        setFichaData(
          response?.data?.map((x: any) => ({label: x.idficha?.nombre, value: x.idficha?._id})) ?? []
        )
      } else {
        console.log(response.msg)
      }
    })
  }

  useEffect(() => {
    if (selectedProcess !== '') {
      getFichasxProceso(selectedProcess)
    }
  }, [selectedProcess])

  console.log(fichaData)
  return (
    <>
      <Row>
        <Col sm>
          <Form.Group>
            <Form.Control
              type='text'
              placeholder='Buscar...'
              value={searchQuery}
              onChange={handleSearchChange}
              className='my-2'
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className='my-2'>
        <Col sm>
          <span className='fw-bold'>Proceso:</span>
          <Select
            options={procesosAdminOptions}
            onChange={(e) => setSelectedProcess(e?.value ?? '')}
            defaultValue={procesosAdminOptions[0]}
          />
        </Col>
      </Row>

      <Row>
        <Col sm>
          <span className='fw-bold'>Ficha:</span>
          <Select
            options={fichaData}
            aria-label='Select example'
            value={fichaData.find((x) => x.value === idficha)}
            name='idfichas'
            onChange={(event) => handleInputChangeFichas(event)}
          />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex align-self-end justify-content-end mt-2' sm>
          <Form.Check
            type='checkbox'
            id='checkbox-all'
            label={<span style={{color: 'black'}}>Seleccionar Todo</span>}
            onChange={handleChangeAll}
            className='hide-validation'
          />
        </Col>
      </Row>
      <div style={{maxHeight: maxListHeight, overflowY: 'scroll'}}>
        {loadingFichaContent ? (
          <PdfLoadingSpinner />
        ) : (
          inputList.map((group) => {
            const filteredFields = group.fields.filter((item) =>
              item.label.toLowerCase().includes(searchQuery.toLowerCase())
            )

            if (filteredFields.length === 0) {
              return null
            }

            return (
              <>
                <h4 className='my-3 ms-2 fw-bold'>{group.label}</h4>
                <ListGroup style={{maxHeight: '200px', overflowY: 'auto'}}>
                  {filteredFields.map((item) => {
                    const isForcedSelection = [
                      'CS_ApPaterno',
                      'CS_ApMaterno',
                      'CS_Nombres',
                      'CS_Documento',
                      'CS_EmailPersonal',
                    ].includes(item.assignedTo)

                    const isForcedSelectionUpdate = ['CS_Documento'].includes(item.assignedTo)

                    return (
                      <div key={item.identifier}>
                        <ListGroup.Item key={item.identifier} className='d-flex'>
                          <Form.Check
                            type='checkbox'
                            id={`checkbox-dynamic-list-${item.identifier}`}
                            label={item.label}
                            checked={selectedItems.indexOf(item.identifier) !== -1}
                            onChange={(e) => handleToggle(item.identifier)}
                            className='hide-validation'
                            disabled={
                              (!typeUpdate && isForcedSelection) ||
                              (typeUpdate && isForcedSelectionUpdate)
                            }
                          />
                          {item.obligatorio && (
                            <span className='mx-3' style={{color: '#FF0000'}}>
                              *
                            </span>
                          )}
                        </ListGroup.Item>
                      </div>
                    )
                  })}
                </ListGroup>
              </>
            )
          })
        )}
      </div>

      <Form.Group>
        <div className='d-flex justify-content-end'>
          <Button variant='primary' type='button' className='btn-sm' onClick={() => handleExport()}>
            {!loading && 'Descargar Plantilla'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Descargando...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </Button>
        </div>
      </Form.Group>
    </>
  )
}

export default TagsListGroup
